import React from 'react';
import { Box, Flex, Link, SimpleGrid, Text } from '@chakra-ui/react';
import Image from 'next/legacy/image';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useRouter } from 'next/router';
import { ISearchResultGridProps } from './interfaces';
import { ImageHover, Wrapper } from './SearchResultGridStyled';
import theme from '@src/theme';
import ChakraButton from '@components/Shared/ChakraButton/ChakraButton';

const SearchGrid: React.FC<ISearchResultGridProps> = ({ posts }) => {
  const router = useRouter();
  if (!posts || posts.length === 0) {
    return (
      <Flex justify="center" align="center" direction="column">
        <Text fontFamily="montserrat" mb={10}>
          Sorry, No matching results found
        </Text>
        <ChakraButton
          variant="secondary"
          onClick={() => router.back()}
          faIconName={faChevronLeft}
        >
          Back
        </ChakraButton>
      </Flex>
    );
  }
  return (
    <Box maxW={1150} mb={5} mx="auto" px="20px">
      <SimpleGrid
        columns={[1, 1, 2, 3]}
        spacing={[1, 4, 7, 7]}
        alignItems="stretch"
      >
        {posts?.map((post: any) => (
          <Link key={post.title} href={`/blog/${post.slug?.current}`}>
            <Wrapper key={post.title} w="100%" mb={[5, 0]} cursor="pointer">
              <Box position="relative">
                <Image
                  src={
                    post.mainPhoto?.asset?.url ??
                    'http://via.placeholder.com/350x188'
                  }
                  alt="post image"
                  width={350}
                  height={200}
                  layout="responsive"
                />
                <ImageHover className="image-hover" />
              </Box>
              <Flex
                fontFamily={theme.fonts.montserrat}
                direction="column"
                justify="center"
                align="center"
              >
                <Text
                  align="center"
                  color="grey.300"
                  mt={3}
                  mb={0}
                  fontFamily={theme.fonts.montserrat}
                  fontWeight="bold"
                >
                  {post.title}
                </Text>
                <Text align="center" color="grey.300" fontSize="14px" mb={0}>
                  {post.description}
                </Text>
              </Flex>
            </Wrapper>
          </Link>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default SearchGrid;
